import { StyledContainer } from "./styles";

export default function ErrorFallback() {
  return (
    <StyledContainer>
      <div>
        <h1>Oops! An unexpected error occurred.</h1>
        <p>Refresh the page to try again.</p>
      </div>
    </StyledContainer>
  );
}
